export enum MarketStatus {
    Closed = 0,
    PreOpen = 1,
    Open = 2,
    Paused = 3,
    Settling = 4,
    PostClosePreOpen = 5,
    CoolOff = 6
}

export function getMarketStatusText(status: MarketStatus): string {
    switch (status) {
        case MarketStatus.Closed:
            return "Closed";
        case MarketStatus.PreOpen:
            return "Pre-open"
        case MarketStatus.Open:
            return "Open";
        case MarketStatus.Paused:
            return "Paused";
        case MarketStatus.Settling:
            return "Settling";
        case MarketStatus.PostClosePreOpen:
            return "Post-close/Pre-open";
        case MarketStatus.CoolOff:
            return "Cool off";
        default:
            return "Unknown status";
    }
}